// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {userInfoApi} from './service/allApi'

router.beforeEach((to,from,next)=>{
  let uid = localStorage.getItem("uid")
  let phone = localStorage.getItem("phone")
  const that = this
  if(to.meta.auth){
    userInfoApi().then((res)=>{
      const code = res.data.code
      if(code == 100){
        // console.log(res.data.data)
        localStorage.setItem("user",JSON.stringify(res.data.data))
        next()
      }else if(code == -200){
        router.push('/login')
      }else{
        ElementUI.Message.error("系统出错")
      }
    }).catch((error)=>{
      ElementUI.Message.error("系统出错")
    })
  }else{
    next()
  }
})

Vue.config.productionTip = false

Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js